import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(value);

export default function BankBalance(props) {
  console.log("props.data ", props.data);
  // Explicitly filter the array to ensure ONLY accounts belonging to the "BANK" group are processed
  const ledgerData = props.data || [];
  const totalValueFromKPICard = props.totalValueFromKPICard || [];

  // Dynamically calculate chart width based only on the filtered bank accounts
  const calculatedWidth = Math.max(800, ledgerData.length * 120 + 100);

  return (
    <div
      style={{
        padding: "4px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        margin: "0 auto",
        backgroundColor: "#f8fafc",
        color: "#334155",
        borderRadius: "16px",
        boxShadow:
          "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.03)",
      }}
    >
      <div className="ms-2 p-2">
        <p>
          Total{" "}
          {totalValueFromKPICard?.length > 0
            ? totalValueFromKPICard[0]?.["TotalBankBalance"]
            : ""}
        </p>
      </div>

      {/* 1. DATA TABLE SECTION */}
      <div
        style={{
          overflowX: "auto",
          marginBottom: "40px",
          backgroundColor: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          maxHeight: "300px",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.02)",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "left",
            fontSize: "14px",
          }}
        >
          <thead>
            <tr
              style={{
                borderBottom: "1px solid #e2e8f0",
                backgroundColor: "#f1f5f9",
              }}
            >
              <th
                style={{
                  padding: "16px",
                  fontWeight: "600",
                  color: "#475569",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                }}
              >
                Account Name
              </th>
              <th
                style={{
                  padding: "16px",
                  fontWeight: "600",
                  color: "#475569",
                  fontSize: "12px",
                  letterSpacing: "0.05em",
                }}
              >
                Code
              </th>
            </tr>
          </thead>
          <tbody>
            {ledgerData.map((row) => (
              <tr
                key={row.Account_Code}
                style={{
                  borderBottom: "1px solid #e2e8f0",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f8fafc")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <td
                  style={{
                    padding: "16px",
                    fontWeight: "600",
                    color: "#0f172a",
                    maxWidth: "280px",
                  }}
                >
                  {row.AccountName}
                </td>
                <td
                  style={{
                    padding: "16px",
                    color: "#64748b",
                    fontSize: "13px",
                  }}
                >
                  {row.BankBalance}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
